import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getItemsSalesRequest = (
  token,
  startDate,
  endDate,
  selectedRestaurant
) => {
  const organizationId = localStorage.getItem("organizationId");

  const data = selectedRestaurant
    .map((restaraunt) => {
      return `RestaurantIds=${restaraunt}&`;
    })
    .join("");

  const url =
    apiURl +
    "items/getSales?startDate=" +
    startDate +
    "&endDate=" +
    endDate +
    "&" +
    data +
    "organizationId=" +
    organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

export { getItemsSalesRequest };
